// import Select, { SelectChangeEvent } from '@mui/material/Select';
import { chartIconList, checkCustomIcon } from '../../../utils/widgetLibrary/IconTemplates/checkCustomIcon';
import { iconList_3d, iconList_general, Icon_Library, roomState_iconList, roomState_Icons } from '../../../utils/widgetLibrary/IconTemplates/Icon_library';
import MenuItem from '@mui/material/MenuItem';
import { useState,useEffect,useRef } from 'react';
import Button from '../../ui/buttons';
import Select, { components } from 'react-select';
import { cn } from 'src/lib/utils';

export const SelectNormalIcons = ({updateSetupDetails, setupDetails,defaultIcon, insideMeasurement=false}) => {
    const [selectedIcon, setSelectedIcon] = useState(defaultIcon?.[0])
    const [tab, setTab] = useState('')
    const [AvailableIcons, setAvailableIcons] = useState([])

    
    const handleChange = (e) => {
        setSelectedIcon(e.target.value);
   
        if(insideMeasurement){
            updateSetupDetails({
                ...setupDetails,
                'measurement': [{
                  ...setupDetails.measurement?.[0],
                  icon: e.target.value
                }]
              });
        }else{
            updateSetupDetails({
                ...setupDetails,
                icon: [e.target.value],
            })
        }
       // console.log(setupDetails)
    };

    useEffect(() => {
        if(tab=='3d'){
            setAvailableIcons(iconList_3d)
        }else if(tab=='general'){
            setAvailableIcons(iconList_general)
        }
        
        return () => {
            setAvailableIcons([])
        }
    }, [tab])
    

    const handleTabsChange = (tab_name) => {
        setTab(tab_name)
        
    }
    
    return ( 
        <>
            <div className="mt-3">
                    <p className="text-sm text-gray-500">Select Icon</p>
                    <nav className="flex mt-1 space-x-2" aria-label="Tabs" role="tablist">
                        <Button tabs selected={tab==='general'} onClick={()=>handleTabsChange('general')} type="button" role="tab">General Icons</Button>
                        <Button tabs selected={tab==='3d'} onClick={()=>handleTabsChange('3d')} type="button"  role="tab">3D Icons</Button>

                    <div>{Icon_Library(selectedIcon, 'h-9 w-9 mb-2',true)}</div>
                    </nav>
            </div>

            <section className='grid w-full grid-cols-5 col-span-3 gap-1 p-2 text-gray-500 list-none border border-gray-200 rounded-b-md xl:grid-cols-7 3xl:grid-cols-11'>
                {AvailableIcons?.map(icon => {
                    let isChecked = selectedIcon===icon
                    return (
                        <div key={icon} className={isChecked ? "relative shadow-xl ":'opacity-90'}>
                        {isChecked && <i className="absolute left-0 z-20 text-xl transition ease-in-out bg-white rounded-full duration-400 ri-checkbox-circle-line text-vekin -top-2"></i>}
                            <input type="radio" name="widget_icon" id={icon} required className="hidden" value={icon}  onChange={(e)=>handleChange(e)}/>
                            <label className="relative cursor-pointer " htmlFor={icon}>
                                <div className={`flex justify-center border p-1 rounded-md hover:border-vekin ${isChecked && 'border-vekin border-2'}`}>
                                    {Icon_Library(icon, 'h-8 w-8',true)}
                                </div>
                            </label>
                        </div>
                    )
                }
                    )}
                
            </section>
        </>
     );
}
 



export const SelectChartIcon = ({setIconSelect,defaultIcon, selectedWidget,selectedColor}) => {
    const refPopUp = useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    
    const handleOptionClick = (selectedIcon) =>{
            setIconSelect(selectedIcon, 'icon')
            setIsDropdownOpen(false);
    } 

    const iconList = ["Line Chart V2","Line Chart Diff","Line Chart","Radar Chart"].includes(selectedWidget)? chartIconList : roomState_iconList


    // console.log(iconList)
  
    useEffect(() => {
      // to close the icon select when user click outside the popup box
      function handleClickOutside(event) {
        if (refPopUp?.current && !refPopUp?.current.contains(event.target)) {
          setIsDropdownOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [refPopUp, isDropdownOpen]);
    

    
    return (
    <div className='w-20 h-1/2'>
                <div className="relative inline-block w-full text-left">
                  <div className='w-full'>
                    <button
                      type="button"
                      className="flex flex-row items-center justify-center flex-1 w-full h-full col-span-2 py-1.5 pl-2 text-sm text-gray-700 border border-gray-300 rounded-md outline-none"
                      id="options-menu"
                      aria-haspopup="true"
                      aria-expanded="true"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      {defaultIcon ? checkCustomIcon(defaultIcon,'h-7 w-7 mx-auto', selectedColor?? "gray" ): '---'}
                      <svg
                        className="w-5 h-5 ml-2 -mr-1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>

                  <div
                    ref={refPopUp}
                    className={cn(isDropdownOpen ? '' : 'hidden', "origin-top-right widget absolute -right-12 mt-2 w-20 -top-40 h-72 z-[50] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 overflow-auto")}
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                  >
                      
                    {iconList.map((icon) => (
                      <div
                        key={icon}
                        className={`${
                          defaultIcon === icon ? 'bg-gray-100' : ''
                        } block px-4 py-2  text-sm text-gray-700 hover:bg-vekin/30`}
                        role="menuitem"
                        onClick={() => handleOptionClick(icon)}
                      >
                        {checkCustomIcon(icon,'h-8 w-8 mx-auto', selectedColor?? "gray" )} 
                      </div>
                    ))}
                  </div>
                </div>
               
    </div>
        
   
    );
  }
